import './index.css';
import { jsx } from 'react/jsx-runtime';
import { validateSurface } from '../../globals.js';
import styles from './status-text.module.scss.js';

const StatusText = ({ errorText, error, success, successText, surface: surfaceProp = 'lightPrimary', }) => {
    const surface = validateSurface(surfaceProp);
    const wrapperStyles = [styles.status, styles[surface.toLowerCase()]];
    if (error)
        wrapperStyles.push(styles.error);
    if (success)
        wrapperStyles.push(styles.success);
    return (jsx("div", { className: wrapperStyles.join(' '), children: jsx("p", { className: styles.statusText, children: error ? errorText : success && successText }) }));
};

export { StatusText, StatusText as default };
